module.exports = __webpack_public_path__ + "img/2018_S.a6966688.png";